module.exports = __webpack_public_path__ + "img/laptop-card-right.b2949113.png";